var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5H14.5C14.7761 3.5 15 3.72386 15 4V6C15 6.27614 14.7761 6.5 14.5 6.5H10.5V3.5Z",
    fill: "#8D33FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3C10.6381 3.00003 10.75 3.11198 10.7499 3.25005L10.7487 9.21054C10.7486 9.34861 10.6367 9.46051 10.4986 9.46048C10.3605 9.46045 10.2486 9.3485 10.2487 9.21043L10.2499 3.24995C10.25 3.11188 10.3619 2.99997 10.5 3Z",
    fill: "#8D33FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06662 20.2519L10.0567 8.01927C10.2503 7.68035 10.7403 7.68415 10.9287 8.02603L14.3377 14.2127L15.7716 11.6778C15.9648 11.3364 16.4579 11.3402 16.6458 11.6846L21.3233 20.2601C21.5051 20.5933 21.2639 20.9996 20.8844 20.9996H17.2507C17.2443 20.9998 17.2378 20.9999 17.2312 20.9999H3.50074C3.11683 20.9999 2.87614 20.5852 3.06662 20.2519Z",
    fill: "#FF8833"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_2085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 7,
    width: 19,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06662 20.2519L10.0567 8.01927C10.2503 7.68035 10.7403 7.68415 10.9287 8.02603L14.3377 14.2127L15.7716 11.6778C15.9648 11.3364 16.4579 11.3402 16.6458 11.6846L21.3233 20.2601C21.5051 20.5933 21.2639 20.9996 20.8844 20.9996H17.2507C17.2443 20.9998 17.2378 20.9999 17.2312 20.9999H3.50074C3.11683 20.9999 2.87614 20.5852 3.06662 20.2519Z",
    fill: "#731DE0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_2085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 10.4998H7.5V7.49976H14V10.4998Z",
    fill: "#8D33FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.7786547043854580ae9dd4b7f61e7775.svg";
export { ForwardRef as ReactComponent };